var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import MuiDialogTitle from '@mui/material/DialogTitle';
import { IconButton } from '../../icon-button';
import { XIcon } from '../../icon';
import { styled } from '../../styled';
import { Text } from '../../text';
import { useMergedClasses } from '../../styles/classes';
import clsx from '../../utils/clsx';
import { dialogTitleClasses, getDialogTitleUtilityClass } from './dialog-title-classes';
var dialogTitleComponentName = 'QuantumDialogTitle';
export var Root = styled(MuiDialogTitle, {
    name: dialogTitleComponentName,
    slot: 'Root',
})({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
});
export var DialogTitle = React.forwardRef(function (props, ref) {
    var children = props.children, onClose = props.onClose, _a = props.disableTypography, disableTypography = _a === void 0 ? false : _a, id = props.id, className = props.className, propClasses = props.classes, dialogTitleProps = __rest(props, ["children", "onClose", "disableTypography", "id", "className", "classes"]);
    var classes = useMergedClasses(dialogTitleClasses, getDialogTitleUtilityClass, propClasses);
    return (React.createElement(Root, __assign({}, dialogTitleProps, { className: clsx(classes.root, className), ref: ref }),
        disableTypography ? (children) : (React.createElement(Text, { id: id, className: classes.title, variant: "h5", color: "textPrimary" }, children)),
        !!onClose && (React.createElement(IconButton, { shape: "circular", variant: "contained", "aria-label": "Close", size: "small", className: classes.closeButton, onClick: function (event) { return onClose(event, 'closeClick'); } },
            React.createElement(XIcon, null)))));
});
